// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__DI_He","itemTitle":"ClientEmergencyInfo_itemTitle__3chQw","itemText":"ClientEmergencyInfo_itemText__VozjU"};